export default {
  common: {
    home: 'Home',
    booking: 'Booking',
    appointments: 'Appointments',
    settings: 'Settings',
    save: 'Save',
    cancel: 'Cancel',
    back: 'Back',
    continue: 'Continue',
    confirm: 'Confirm',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    date: 'Date',
    time: 'Time',
    status: 'Status',
    service: 'Service',
    store: 'Store',
    all: 'All',
    search: 'Search',
    view: 'View',
    edit: 'Edit',
    actions: 'Actions',
    delete: 'Delete',
    saving: 'Saving...',
    deleting: 'Deleting...',
    backToHome: 'Back to Home'
  },
  home: {
    hero: {
      title: 'Welcome to our booking platform',
      subtitle: 'Book your appointment in just a few clicks',
      cta: 'Book now'
    },
    howItWorks: {
      title: 'How it works?',
      step1: {
        title: '1. Choose your store',
        description: 'Select the store closest to you'
      },
      step2: {
        title: '2. Select a time slot',
        description: 'Choose a date and time that suits you'
      },
      step3: {
        title: '3. Confirm your appointment',
        description: 'Receive a confirmation email'
      }
    },
    advantages: {
      title: 'Why choose us?',
      simple: {
        title: 'Simple and fast',
        description: 'Book in less than 2 minutes'
      },
      flexible: {
        title: 'Flexible',
        description: 'Easily modify or cancel your appointment'
      },
      reminders: {
        title: 'Automatic reminders',
        description: 'Receive email notifications'
      }
    }
  },
  stores: {
    title: 'Our Stores',
    comingSoon: 'Coming Soon',
    availableServices: 'Available Services',
    bookNow: 'Book Now',
    selectStore: 'Select a Store',
    noStores: 'No stores available',
    noStoresFound: 'No stores found',
    closed: 'Closed'
  },
  services: {
    title: 'Our Services',
    escooter: {
      title: 'Electric Scooters',
      description: 'Rental and maintenance of electric scooters'
    },
    emotorcycle: {
      title: 'Electric Motorcycles',
      description: 'Rental and maintenance of electric motorcycles'
    },
    ebike: {
      title: 'E-Bikes',
      description: 'Rental and maintenance of electric bikes'
    },
    repair: 'Repair',
    trial: 'Test Ride',
    trial_description: 'Try our electric vehicles',
    repair_description: 'Repair and maintenance service',
    selectService: 'Select a Service',
    TRIAL: 'Test Ride',
    REPAIR: 'Repair Service'
  },
  booking: {
    title: 'Book an Appointment',
    selectStore: 'Select this store',
    steps: {
      store: 'Store',
      service: 'Service',
      datetime: 'Date & Time',
      info: 'Information'
    },
    selectDate: 'Select a date',
    selectTime: 'Select a time',
    personalInfo: 'Your Information',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    comments: 'Comments (optional)',
    submit: 'Confirm Appointment',
    success: 'Booking confirmed',
    error: 'Booking error',
    confirmationTitle: 'Booking Confirmation',
    confirmationMessage: 'Your appointment has been successfully booked. You will receive a confirmation email shortly.',
    details: 'Booking Details',
    addToCalendar: 'Add to Calendar',
    addToGoogle: 'Add to Google Calendar',
    addToApple: 'Add to Apple Calendar',
    weekDays: {
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat',
      sun: 'Sun'
    },
    months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December'
    },
    storeClosed: "The store is closed on this day",
    noAvailableSlots: "No available slots for this date"
  },
  appointment: {
    details: 'Appointment Details',
    management: 'Appointment Management',
    description: 'Manage all your customer appointments',
    new: 'New Appointment',
    client: 'Client',
    noAppointments: 'No appointments found',
    searchPlaceholder: 'Search by name, email or phone...',
    status: {
      pending: 'Pending',
      confirmed: 'Confirmed',
      cancelled: 'Cancelled'
    },
    actions: {
      cancel: 'Cancel Appointment',
      reschedule: 'Reschedule Appointment'
    }
  },
  errors: {
    404: {
      title: 'Page not found',
      message: 'Sorry, the page you are looking for does not exist or has been moved.',
      backHome: 'Back to home'
    },
    generic: {
      title: 'An error occurred',
      message: 'Sorry, something went wrong. Please try again later.',
      retry: 'Try again'
    }
  },
  admin: {
    title: 'Administration',
    dashboard: {
      title: 'Dashboard',
      stats: {
        stores: 'Stores',
        employees: 'Employees',
        services: 'Services'
      },
      appointmentsPerDay: 'Appointments per Day',
      appointmentsPerStore: 'Appointments per Store',
      chartComingSoon: 'Chart Coming Soon',
      recentAppointments: 'Recent Appointments',
      noAppointments: 'No appointments',
      table: {
        date: 'Date',
        time: 'Time',
        store: 'Store',
        client: 'Client',
        status: 'Status',
        service: 'Service'
      }
    },
    stores: {
      title: 'Store Management',
      addStore: 'Add Store',
      editStore: 'Edit Store',
      deleteStore: 'Delete Store',
      city: 'City',
      cityKey: 'City Key',
      name: 'Name',
      address: 'Address',
      zip: 'ZIP Code',
      phone: 'Phone',
      email: 'Email',
      status: 'Status',
      services: 'Services',
      workingHours: 'Working Hours',
      isOpen: 'Open',
      isActive: 'Active',
      isComingSoon: 'Coming Soon',
      active: 'Active',
      inactive: 'Inactive',
      confirmDelete: 'Confirm Deletion',
      deleteWarning: 'Are you sure you want to delete this store? This action cannot be undone.',
      loadError: 'Error loading stores',
      saveError: 'Error saving store',
      deleteError: 'Error deleting store',
      createSuccess: 'Store created successfully',
      updateSuccess: 'Store updated successfully',
      deleteSuccess: 'Store deleted successfully',
      noStores: 'No stores found',
      form: {
        name: 'Name',
        city: 'City',
        selectCity: 'Select a city',
        address: 'Address',
        zipCode: 'ZIP Code',
        services: 'Services',
        status: 'Status'
      }
    },
    employees: {
      title: 'Employee Management',
      addEmployee: 'Add Employee',
      editEmployee: 'Edit Employee',
      deleteEmployee: 'Delete Employee',
      name: 'Name',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      phone: 'Phone',
      store: 'Store',
      password: 'Password',
      status: 'Status',
      isActive: 'Active',
      active: 'Active',
      inactive: 'Inactive',
      noStore: 'No store',
      leaveBlankPassword: 'Leave blank to keep current password',
      noEmployees: 'No employees found',
      confirmDelete: 'Confirm Deletion',
      deleteWarning: 'Are you sure you want to delete this employee? This action cannot be undone.',
      loadError: 'Error loading employees',
      saveError: 'Error saving employee',
      deleteError: 'Error deleting employee',
      createSuccess: 'Employee created successfully',
      updateSuccess: 'Employee updated successfully',
      deleteSuccess: 'Employee deleted successfully',
      form: {
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        phone: 'Phone',
        store: 'Store',
        selectStore: 'Select a store',
        role: 'Role',
        status: 'Status'
      }
    }
  },
  roles: {
    manager: 'Manager',
    mechanic: 'Mechanic',
    apprentice: 'Apprentice'
  },
  days: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday'
  },
  auth: {
    login: {
      title: 'Sign in',
      email: 'Email address',
      password: 'Password',
      rememberMe: 'Remember me',
      forgotPassword: 'Forgot your password?',
      submit: 'Sign in',
      loggingIn: 'Signing in...',
      errors: {
        emailRequired: 'Email is required',
        emailInvalid: 'Email is invalid',
        passwordRequired: 'Password is required',
        default: 'Invalid credentials'
      }
    },
    logout: 'Sign out'
  }
} 